import { novaBrand } from "./brands/nova";
import { fitupBrand } from "./brands/fitup";
import { stageBrand } from "./brands/stage";
import type { BrandConfig } from "./brands/types";

const brandMap: Record<string, BrandConfig> = {
  nova: novaBrand,
  fitup: fitupBrand,
  stage: stageBrand,
};

const brandName = import.meta.env.VITE_BRAND ?? "nova";

export const brandConfig: BrandConfig = brandMap[brandName] ?? novaBrand;
